import { render } from "./AddNewAppointmentNoteOverlay.vue?vue&type=template&id=0207b0c8&scoped=true&lang=pug"
import script from "./AddNewAppointmentNoteOverlay.vue?vue&type=script&lang=js"
export * from "./AddNewAppointmentNoteOverlay.vue?vue&type=script&lang=js"

import "./AddNewAppointmentNoteOverlay.vue?vue&type=style&index=0&id=0207b0c8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0207b0c8"]])

export default __exports__